import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => localStorage.getItem('sf_theme') || 'dark');
  // Per-browser preference, not a server-side setting — a visual contrast
  // preference belongs to the person viewing the screen, not something one
  // admin should be able to force on everyone else's browser.
  const [highContrast, setHighContrast] = useState(() => localStorage.getItem('sf_high_contrast') === 'true');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('sf_theme', theme);
  }, [theme]);

  useEffect(() => {
    if (highContrast) document.documentElement.setAttribute('data-contrast', 'high');
    else document.documentElement.removeAttribute('data-contrast');
    localStorage.setItem('sf_high_contrast', String(highContrast));
  }, [highContrast]);

  const toggle = () => setTheme(t => t === 'dark' ? 'light' : 'dark');
  const toggleHighContrast = () => setHighContrast(c => !c);

  return (
    <ThemeContext.Provider value={{ theme, toggle, highContrast, toggleHighContrast }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
